import { Paginator as PrimePaginator } from "primereact/paginator";
import { classNames } from "primereact/utils";

import styles from "./paginator.module.scss";
import type { PaginatorViewProps } from "./types-paginator";

export function PaginatorView({ paginatorRef, className, paginatorProps, pt }: PaginatorViewProps) {
  return (
    <PrimePaginator
      ref={paginatorRef}
      className={classNames(styles.root, className)}
      {...paginatorProps}
      pt={pt}
    />
  );
}
